import registerModule from './register-module';

export default class ParallaxFix {
  constructor(element) {
    this.element = element;
    this.container = this.element.querySelector('.parallax-container');
  }

  initialize() {
    if (!this.container) return;

    this.checkHeight();
    window.addEventListener('resize', () => this.checkHeight());
    window.addEventListener('load', () => this.checkHeight());

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.checkHeight());
      this.resizeObserver.observe(this.container);
      if (this.container.firstElementChild) {
        this.resizeObserver.observe(this.container.firstElementChild);
      }
    }
  }

  checkHeight() {
    const isCurrentlyScrollable = this.element.classList.contains('is-scrollable');

    // Temporarily remove class to get the actual height with padding as it would be in parallax mode
    if (isCurrentlyScrollable) {
      this.element.classList.remove('is-scrollable');
    }

    const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
    const contentHeight = this.container.scrollHeight;

    // Restore the class immediately so the DOM doesn't repaint the removed state
    if (isCurrentlyScrollable) {
      this.element.classList.add('is-scrollable');
    }

    // Disable parallax if content height is more than 100vh
    if (contentHeight > viewportHeight) {
      this.element.classList.add('is-scrollable');
    } else {
      this.element.classList.remove('is-scrollable');
    }
  }
}

registerModule('parallax-fix', ParallaxFix);
